import { LitElement, html, utils } from '@hh/global.js'

class HHHeader extends LitElement {
  static properties = {
    isSticky: {
      type: String,
      attribute: 'is-sticky'
    }
  }

  constructor() {
    super()
  }

  connectedCallback () {
    super.connectedCallback()
    window.addEventListener('resize', this.setSpacerHeight)

    setTimeout(() => {
      this.setSpacerHeight()
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('resize', this.setSpacerHeight)
  }

  setSpacerHeight() {
    const { height: _heightAnnouncementbar } = document
      .querySelector('.js-announcement-bar')
      .getBoundingClientRect()

    const { height: _heightHeader } = document
      .querySelector('.js-header')
      .getBoundingClientRect()

    this._initialHeight = _heightAnnouncementbar + _heightHeader
    this._height = this.enableTransparent ? 0 : this._initialHeight
    this._state = 0
    HH.setCSSVariable('--hh-spacer-height', `${this._height}px`)
    HH.setCSSVariable('--hh-announcement-bar-height', `${_heightAnnouncementbar}px`)
    HH.setCSSVariable('--hh-window-height', `${window.innerHeight}px`)
    HH.setCSSVariable('--hh-header-height', `${_heightHeader}px`)
  }

  closeOpenModals(e) {
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.setAttribute('open', false)
      }
    })
  }

  toggleCart(e) {
    e?.detail?.event?.preventDefault()
    utils.toggle(document.body, ['mini-cart-is-active', 'scroll-lock'])
  }

  render() {
    return html`<slot
      @modalOpened="${this.closeOpenModals}"
      @toggleCart="${this.toggleCart}"
    ></slot>`
  }
}

customElements.define('hh-header', HHHeader)
